// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_login-process__XK0kx {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  top: 12vh;
}
.login_logo__VyoBI {
  margin-top: 36px;
  margin-bottom: 69px;
}
.login_inner__uimB- {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  border: 2px solid #fff;
  padding: 30px 12px;
  max-width: 500px;
  margin: 16px 0;
  border: 2px solid rgba(255, 255, 255, 0.24);
  background: var(--Yalda-BG, #2c719d);
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  border-radius: 12px;
}
.login_overlay__uKouq {
  background: unset;
  backdrop-filter: unset;
}

@media screen and (min-width: 1200px) {
  .login_login-process__XK0kx {
    /* justify-content: space-between; */
  }
  .login_inner__uimB- {
    padding: 32px;
    max-width: 500px;
    margin: 16px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Modals/login/login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EAEX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,oCAAoC;EACpC;;;;0CAIwC;EACxC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":[".login-process {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  top: 12vh;\n}\n.logo {\n  margin-top: 36px;\n  margin-bottom: 69px;\n}\n.inner {\n  max-width: 650px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  border-radius: 32px;\n  border: 2px solid #fff;\n  padding: 30px 12px;\n  max-width: 500px;\n  margin: 16px 0;\n  border: 2px solid rgba(255, 255, 255, 0.24);\n  background: var(--Yalda-BG, #2c719d);\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  border-radius: 12px;\n}\n.overlay {\n  background: unset;\n  backdrop-filter: unset;\n}\n\n@media screen and (min-width: 1200px) {\n  .login-process {\n    /* justify-content: space-between; */\n  }\n  .inner {\n    padding: 32px;\n    max-width: 500px;\n    margin: 16px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-process": `login_login-process__XK0kx`,
	"logo": `login_logo__VyoBI`,
	"inner": `login_inner__uimB-`,
	"overlay": `login_overlay__uKouq`
};
export default ___CSS_LOADER_EXPORT___;
